import {DIALOG_TYPE, LayoutConfig} from "@spartacus/storefront";
import {
  GonvarriQuickStockTitleModalComponent
} from "../components/gonvarri-quick-stock-title-modal/gonvarri-quick-stock-title-modal.component";

export const gonvarriDefaultAddedToCartLayoutConfig: LayoutConfig = {
  launch: {
    GONVARRI_ADDED_TO_CART: {
      inlineRoot: true,
      component: GonvarriQuickStockTitleModalComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
  },
};
